import { render, staticRenderFns } from "./TooltipErdungssimulationBlitzTrafo.vue?vue&type=template&id=246be956&scoped=true&"
import script from "./TooltipErdungssimulationBlitzTrafo.vue?vue&type=script&lang=js&"
export * from "./TooltipErdungssimulationBlitzTrafo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246be956",
  null
  
)

export default component.exports